import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { useProgramFilters } from '../store/program-filters';

export type TDeleteProgramParams = {
  id: string;
};

export function deleteProgram({ id }: TDeleteProgramParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/programs/${id}`);
}

type MutationFn = typeof deleteProgram;

type TUseDeleteProgramParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteProgram({ config }: TUseDeleteProgramParams = {}) {
  const { gte, lte, state, channel_id, priorities, channel_media_type, paginationValues } =
    useProgramFilters();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('El programa no existe');
      }
      addErrorNotification('No se ha podido eliminar el programa');
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [
          'programs',
          {
            gte,
            channel_id,
            lte,
            state,
            priorities,
            channel_media_type,
            ...Object.values(paginationValues || {}),
          },
          ,
        ],
      });
      addSuccessNotification('El programa se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteProgram,
  });
}
